import { HttpClient } from '@angular/common/http';
import {
  Component,
  OnInit,
  TemplateRef,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { MapsLocationDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/maps-location-dialog/maps-location-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { WebcamImage } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { UserRegDetails } from 'src/app/models/user';
import { Visitor } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-create-incident',
  templateUrl: './create-incident.component.html',
  styleUrl: './create-incident.component.scss',
})
export class CreateIncidentComponent {
  private trigger: Subject<any> = new Subject();
  private nextWebcam: Subject<any> = new Subject();
  public webcamImage!: WebcamImage;
  @ViewChild('phoneInput', { read: ElementRef, static: false })
  phoneInputRef: ElementRef;
  @ViewChild('CreateManualEventDialog', { static: true })
  createManualEventDialog: TemplateRef<any>;
  selectedOption: string = 'incident'; // Default to incident
  screenSize: ScreenType;
  ScreenType = ScreenType;
  options = [
    { value: 'incident', viewValue: 'Raise Incident' },
    { value: 'complaint', viewValue: 'Complain' },
  ];
  timeNow = Date.now();
  isDeviceSelected = false;
  showWebcam = false;
  deviceSelected = '';
  availableDevices: any[] = [];
  eventEvidence: any = '';
  sysImage = '';
  isCamera = false;
  incidentTypes: string[] = [
    'Abandoned Object',
    'ANPR Unverified',
    'ANPR Verified',
    'Claims',
    'Communication Failure',
    'Custom Incident',
    'Device Faulty',
    'Device Offline',
    'Electricity Incident',
    'Face Unverified',
    'Face Verified',
    'Fire Unverified',
    'Fire Verified',
    'General Activity',
    'Housekeeping',
    'Incident',
    'Infrastructure Damage',
    'Intrusion',
    'Link Activity',
    'Loss/Damage of Property',
    'Over Utilised Energy',
    'Plumbing Incident',
    'Possible Crime',
    'Riot/Protest',
    'Security Incident',
    'Settled Claims',
    'Suspicious Behaviour',
    'Unattended Incident',
    'Unattended SoS',
    'UncheckedOutVisitor',
    'Unidentified Person',
    'Unmonitored Asset',
    'Unmonitored logs/activity',
    'Unsettled Claims',
    'Unverified Vehicle',
    'Unverified Visitor',
    'Unauthorised/Intruded Entry',
    'Theft/Pilferage',
    'Under Utilised Energy',
  ];
  selectedFrequency: string;
  selectedDays: string[] = [];
  selectedDates: number[] = [];
  daysOfWeek: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  datesOfMonth: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  viewIncident: string = null;
  selectedLocations: { lat: number; lng: number }[] = [];
  selectedUsersControl = new FormControl();
  isOwnerSelected = false;
  filteredUsers: Observable<IOwnerDetails[]>;
  incidentManualEvent = this.formbuilder.group({
    incidentType: ['manual', Validators.required],
    incidentName: ['', Validators.required],
    incidentDescription: [''],
    incidentLocation: [''],
    sourceAssetId: [''],
    sourceAsset: [''],
    incidentStatus: ['0', Validators.required],
    assignedToUserId: [''],
    assignedTo: [''],
    incidentCriticality: ['', Validators.required],
    eventOwnerName: [''],
    eventOwnerEmail: ['', [Validators.email]],
    eventOwnerId: [''],
    eventOwnerHostId: [''],
    eventOwnerPhone: [''],
    eventOwnerType: [],
    eventEvidence: [''],
    eventCreatedBy: [''],
    eventCreatedByUserID: [''],
    isLocationAdded: [false],
    SelectedUsers: this.formbuilder.array([], Validators.required),
  });
  lodgeComplaintTicket = this.formbuilder.group({
    Assignee: [''],
    assignedAdminId: [''],
    assignedAdminName: [''],
    complainSubject: [null, Validators.required],
    complainDescription: ['', Validators.required],
    incidentCriticality: ['', Validators.required],
    claimAmount: [''],
    claimType: [''],
    attachments: [],
    leaveType: ['1'],
    singleDate: [new Date()],
    startDate: [new Date()],
    endDate: [new Date()],
    multipleDate: [],
    isRecurring: false,
    selectedFrequency: [''],
    selectedDays: new FormControl([]), // Add this control
    selectedDates: new FormControl([]),
    SelectedUsers: this.formbuilder.array([], Validators.required),
  });
  usersTemp: string[] = [];
  orgUserList: UserRegDetails[] = [];
  filteredAssignee: UserRegDetails[] = [];
  visitorDetails: Visitor[] = [];
  selectedAttachments: File[] = [];
  selectedMultipleAttachment: ISelectedAttachments[] = [];

  constructor(
    private formbuilder: FormBuilder,
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  onSelectionChange(event: any): void {
    this.selectedOption = event.value;
  }
  captureImg(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.sysImage = webcamImage!.imageAsDataUrl;
    this.eventEvidence = this.sysImage;
    this.incidentManualEvent.controls.eventEvidence.setValue(
      this.eventEvidence
    );
  }
  onUploadEvidence(event: any) {
    if (event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.eventEvidence = event.target.result;
        this.incidentManualEvent.controls.eventEvidence.setValue(
          this.eventEvidence
        );
        this.cdr.detectChanges();
      };
    }
  }
  onClickOpenCamera() {
    this.isCamera = true;
    if (!navigator.mediaDevices?.enumerateDevices) {
      console.log('enumerateDevices() not supported.');
    } else {
      (async () => {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: true,
        });
        await navigator.mediaDevices
          .enumerateDevices()
          .then((devices) => {
            devices.forEach((device) => {
              if (device && device.kind === 'videoinput') {
                this.availableDevices.push(device);
              }
            });
          })
          .catch((err) => {
            console.error(`${err.name}: ${err.message}`);
          });
        stream.getTracks().forEach((track) => track.stop());
      })();
    }
  }
  getSnapshot(): void {
    this.trigger.next(void 0);
    this.showWebcam = !this.showWebcam;
  }
  onDeviceSelectChange(val: any) {
    this.isDeviceSelected = true;
    this.showNextWebcam(val);
  }
  clearInputField(): void {
    this.selectedUsersControl.setValue(''); // Clear the input field value
  }
  addUser(event: any): void {
    const value = event.option.value;
    if (value && !this.usersTemp.includes(value)) {
      this.usersTemp.push(value);
      const matchedUser = this.orgUserList.find(
        (user) =>
          (user.firstname + ' ' + user.lastname).toLowerCase() ===
          value.toLowerCase()
      );
      const item = {
        HostName:
          matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
        HostUserId: matchedUser.userId,
        HostEmail: matchedUser.email,
        HostPhone: matchedUser.phoneNumber,
      };
      this.selected.push(this.formbuilder.control(item));
    }
    setTimeout(() => {
      this.selectedUsersControl.setValue('');
    }, 250);
    event.option.deselect();
  }
  removeUser(user: string): void {
    const index = this.usersTemp.indexOf(user);
    const formArray = this.incidentManualEvent.get(
      'SelectedUsers'
    ) as FormArray;
    if (index >= 0) {
      this.usersTemp.splice(index, 1);
      formArray.removeAt(index);
    }
  }
  ownerSelect(selectedOwner: IOwnerDetails) {
    this.incidentManualEvent.controls['eventOwnerId'].setValue(
      selectedOwner.userid
    );
    this.incidentManualEvent.controls['eventOwnerEmail'].setValue(
      selectedOwner.email
    );
    this.incidentManualEvent.controls['eventOwnerEmail'].disable();
    this.incidentManualEvent.controls['eventOwnerName'].setValue(
      selectedOwner.fullname
    );

    this.incidentManualEvent.controls['eventOwnerPhone'].setValue(
      selectedOwner.mobile
    );
    setTimeout(() => {
      const inputEl: HTMLInputElement =
        this.phoneInputRef?.nativeElement?.querySelector('input');
      if (inputEl) {
        inputEl.value = selectedOwner.mobile;
        inputEl.dispatchEvent(new Event('input')); // To trigger binding
      }
    });
    this.cdr.detectChanges();
    const ownerType =
      selectedOwner.type === 0
        ? 'User'
        : selectedOwner.type === 1
        ? 'Employee'
        : selectedOwner.type === 3
        ? 'New'
        : 'Visitor';
    this.incidentManualEvent.controls['eventOwnerType'].setValue(ownerType);

    if (selectedOwner.type === 2) {
      const host = this.visitorDetails.find(
        (x) => x.visitorID.toLowerCase() === selectedOwner.userid.toLowerCase()
      );
      if (host) {
        this.incidentManualEvent.controls['eventOwnerHostId'].setValue(
          host.hostUserId
        );
      }
    }

    this.isOwnerSelected = true;
    this.cdr.detectChanges();
  }
  getCustomPhoneNumber(val: string): string {
    if (val && val.length > 4) {
      // Extract the last 4 digits
      const last4Digits = val.slice(-4);
      // Mask the rest of the phone number
      const maskedPart = 'xxx-xxx-';
      return maskedPart + last4Digits;
    } else {
      // Return the original value if it's too short
      return val;
    }
  }
  onClickOpenMap() {
    const dialogRef = this.dialog.open(MapsLocationDialogComponent, {
      data: { header: 'Incident Location', isMultipleMarker: false },
    });
    dialogRef.afterClosed().subscribe((x) => {
      if (x) {
        this.selectedLocations = [];
        this.getLocationAddress(JSON.parse(x)).subscribe((response: any) => {
          if (response && response.results && response.results.length > 0) {
            const address = response.results[0].formatted_address;
            this.viewIncident = address;
          }
        });
        this.selectedLocations.push(JSON.parse(x));
        this.incidentManualEvent.controls['incidentLocation'].setValue(
          JSON.stringify(this.selectedLocations)
        );
        this.incidentManualEvent.controls['isLocationAdded'].setValue(true);
      }
    });
  }
  getLocationAddress(val: any) {
    const lat = val.lat;
    const lng = val.lng;
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${'AIzaSyCQSAPyJAtLpIfNx-6oyXpn270bS0hVP18'}`;

    return this.http.get(geocodeUrl);
  }
  createManualEvent() {
    this.incidentManualEvent.controls.eventCreatedBy.setValue(
      localStorage.getItem('FullName')
    );
    this.incidentManualEvent.controls.eventCreatedByUserID.setValue(
      localStorage.getItem('UserId')
    );
    // this.store.dispatch(
    //   new fromDashboardActions.CreateManualIncident(
    //     this.incidentManualEvent.value
    //   )
    // );
    const dialogRef = this.dialog.open(this.createManualEventDialog, {
      disableClose: true,
      data: '',
    });
  }
  onChangeComplainType(val: any) {
    const isClaimSelected = val.value === 'Claim';
    this.lodgeComplaintTicket.get('Assignee').enable();

    this.lodgeComplaintTicket.get('leaveType').setValidators(null);
    this.lodgeComplaintTicket.get('singleDate').setValidators(null);

    this.lodgeComplaintTicket
      .get('claimType')
      .setValidators(isClaimSelected ? [Validators.required] : null);
    this.lodgeComplaintTicket
      .get('claimAmount')
      .setValidators(isClaimSelected ? [Validators.required] : null);

    // Update the validity status of the form control
    this.lodgeComplaintTicket.get('claimType').updateValueAndValidity();
    this.lodgeComplaintTicket.get('claimAmount').updateValueAndValidity();
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
  onAttachmentSelected(event: any): void {
    const files: FileList = event.target.files;
    const attachedContents: string[] = []; // Array to store file contents (optional)
    for (let i = 0; i < files.length; i++) {
      this.selectedAttachments.push(files[i]);
      const file = files[i];
      const reader = new FileReader();

      reader.onload = (e) => {
        const contents = e.target.result as string;
        attachedContents.push(contents); // Add content to the array (optional)
        this.selectedMultipleAttachment.push({
          selectedAttachment: file,
          attachedContent: contents,
          attachedContentName: file.name,
          attachedContentType: file.type,
        });
        this.lodgeComplaintTicket
          .get('attachments')
          .setValue(this.selectedMultipleAttachment);
      };
      reader.readAsDataURL(file);
      this.lodgeComplaintTicket
        .get('attachments')
        .setValue(this.selectedMultipleAttachment); // Update form control
    }
  }
  onFrequencyChange(event: any) {
    console.log(
      'Selected Frequency:',
      this.lodgeComplaintTicket.controls.selectedFrequency.value
    );
    console.log('Selected Days:', this.selectedDays);
    console.log('Selected Dates:', this.selectedDates);
  }
  selectionLimit(event: MatSelectChange, type: 'day' | 'date') {
    const selectedFrequency =
      this.lodgeComplaintTicket.controls.selectedFrequency.value;
    const maxSelection =
      selectedFrequency === 'twiceAWeek' || selectedFrequency === 'twiceAMonth'
        ? 2
        : null;

    if (maxSelection && event.source.value.length > maxSelection) {
      // Remove the first selected item to keep only two selections
      event.source.value.shift();
      this.lodgeComplaintTicket.controls[
        type === 'day' ? 'selectedDays' : 'selectedDates'
      ].setValue([...event.source.value]);
    }
  }
  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
    this.showWebcam = true;
  }
  get invokeObservable(): Observable<any> {
    return this.trigger.asObservable();
  }
  get nextWebcamObservable(): Observable<any> {
    return this.nextWebcam.asObservable();
  }
  get selected() {
    return this.incidentManualEvent.get('SelectedUsers') as FormArray;
  }
}
interface IOwnerDetails {
  userid: string;
  fullname: string;
  type: number;
  email: string;
  mobile: string;
  // 0 -> User
  // 1 -> Employee
  // 2 -> Visitor
  // 3 -> New
}
interface ISelectedAttachments {
  selectedAttachment: File;
  attachedContent: string;
  attachedContentName: string;
  attachedContentType: string;
}
